(() => {
  const imageUrl = 'https://cdn.shopify.com/s/files/1/1009/3127/3015/files/klaxon-modern-living.jpg?v=1789451496';

  function icon(type) {
    const icons = {
      home: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10v9h13v-9M9 19v-6h6v6"/></svg>',
      daily: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2M8 3.8 6.2 2.7M16 3.8l1.8-1.1"/></svg>',
      design: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 19 19 5M6 7l-2 4 4 2 2-4-4-2ZM14 13l-2 4 4 2 2-4-4-2Z"/><path d="m15 4 1 3 3 1-3 1-1 3-1-3-3-1 3-1z"/></svg>',
      support: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 13v-2a8 8 0 0 1 16 0v2"/><path d="M4 12h3v6H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 1-2ZM20 12h-3v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-1-2Z"/><path d="M17 18c-.8 2-2.4 3-5 3"/></svg>'
    };
    return icons[type] || icons.home;
  }

  function enhanceWhySection(scope = document) {
    const sections = scope.querySelectorAll ? scope.querySelectorAll('.klx-home .klx-section') : [];
    let section = null;
    sections.forEach((candidate) => {
      if (section || candidate.dataset.klxWhyEnhanced === 'true') return;
      const eyebrow = candidate.querySelector('.klx-heading .klx-eyebrow');
      const title = candidate.querySelector('.klx-heading h2');
      if (eyebrow && title && eyebrow.textContent.trim().toUpperCase() === 'WHY KLAXON' && title.textContent.trim() === 'Furniture Made for Everyday Use') section = candidate;
    });
    if (!section) return;

    const container = section.querySelector('.klx-container');
    if (!container) return;

    section.dataset.klxWhyEnhanced = 'true';
    section.classList.add('klx-why-premium');

    container.innerHTML = `
      <div class="klx-why-premium__panel">
        <div class="klx-why-premium__visual" data-klx-why-reveal>
          <div class="klx-why-premium__image-shell">
            <img class="klx-why-premium__image" src="${imageUrl}" alt="KLAXON furniture in a modern living room" width="1600" height="1200" loading="lazy">
          </div>
        </div>

        <div class="klx-why-premium__content">
          <div class="klx-eyebrow" data-klx-why-reveal>WHY KLAXON</div>
          <h2 id="klx-why-premium-title" data-klx-why-reveal data-delay="1">Furniture Made for Everyday Use</h2>
          <p class="klx-why-premium__lead" data-klx-why-reveal data-delay="2">Straightforward designs, useful storage and support when you need it.</p>
          <div class="klx-why-premium__values">
            <article class="klx-why-premium__card" data-klx-why-reveal data-delay="1">
              <div class="klx-why-premium__card-top"><span class="klx-why-premium__icon">${icon('home')}</span></div>
              <strong>Fits Real Homes</strong>
              <p>Furniture for work, dining, storage and daily living.</p>
            </article>
            <article class="klx-why-premium__card" data-klx-why-reveal data-delay="2">
              <div class="klx-why-premium__card-top"><span class="klx-why-premium__icon">${icon('daily')}</span></div>
              <strong>Useful Every Day</strong>
              <p>Products for the tasks that happen at home every day.</p>
            </article>
            <article class="klx-why-premium__card" data-klx-why-reveal data-delay="3">
              <div class="klx-why-premium__card-top"><span class="klx-why-premium__icon">${icon('design')}</span></div>
              <strong>Clean, Modern Look</strong>
              <p>Warm finishes and simple forms that work across modern interiors.</p>
            </article>
            <article class="klx-why-premium__card" data-klx-why-reveal data-delay="4">
              <div class="klx-why-premium__card-top"><span class="klx-why-premium__icon">${icon('support')}</span></div>
              <strong>Help When You Need It</strong>
              <p>Product information, order help and customer support are easy to find.</p>
            </article>
          </div>
        </div>
      </div>`;

    initReveal(section);
  }

  function initReveal(section) {
    const items = section.querySelectorAll('[data-klx-why-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -4% 0px' });
    items.forEach(el => observer.observe(el));
  }

  const run = () => enhanceWhySection(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', (event) => enhanceWhySection(event.target));
})();